export default "__VITE_PUBLIC_ASSET__6d3bbee8__"